<script>
import config from "../../config";
import pagination from "laravel-vue-pagination";
import { deliveryZoneService} from '../../services';
import { debounce, error_message, success_message} from "../../Helper/helper";

export default {
    components: { pagination },
    data() {  
        const {orderBy,sortBy,status} = this.$route.query;
        return {
            sortBy: sortBy || "id",
            sortDesc: orderBy && orderBy != '' ? true : orderBy,
            zones:[],
            zoneData:[],
            zoneCount: '',
            paginations:{},
            limit:2,
            search:'',
            status: status == undefined ? "1" :status,
            config:config,
            loading:true,
            isDownloading: false,
            searchData:debounce(()=>{
                const {status,orderBy,sortBy} = this.$data;
                this.$router.replace({name: 'list', query: {status,orderBy,sortBy}})
                this.getDeliveryZone();   
            },500),
            fields: [
                { key: "id", label: "#", sortable: true },
                { key: "image", label: "Image", sortable: false,thClass:"dis-event" },
                { key: 'name',label: this.trans.get("__JSON__.Delivery Zone"), sortable: true },
                { key: 'status',label: this.trans.get("__JSON__.Status"), sortable: false,thClass:"dis-event" },
                { key: 'action',label: this.trans.get("__JSON__.Action"), sortable: false,thClass:"dis-event" }
            ]
        }
    },
    mounted() {
        this.getDeliveryZone(1);
    },
    methods:{
        downloadsCSV: function(){
            let zoneData = '\ufeff' + 'Postal Code,Admin Name,Email,Status\n'
            this.zoneData.forEach(el=> {
                var line = el['last_name'] + ',' + el['user_name'] + ',' + el['email'] + ',' + (el['status'] == 0 ? 'Active' : 'Inactive') +'\n'
                zoneData +=line;
            })

            var blob = new Blob([ zoneData ], { "type" : "csv/plain" });
            var date = new Date().toLocaleString();
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'Delivery_Zone_'+date+'.csv'
            link.click()
        },
        
        getDeliveryZone(page){
            this.loading = true;
            var filters = {
                search: this.search,
                status: this.status,
                sortBy: this.sortBy,
                orderBy: this.sortDesc ? "desc" : "asc",
                page: page && page > 0 ? page : 1,
            }
            deliveryZoneService.getDeliveryZone(filters)
            .then(response => {
                this.loading = false;
                this.paginations = response.data.result;
                this.zones = response.data.result.data;
                this.zoneCount = response.data.result.data.length;
            });
        },
        zoneExportCsv(){
            this.isDownloading = true;
            deliveryZoneService.zoneExportCsv({status: this.status, sortBy: this.sortBy, orderBy: this.sortDesc ? 'desc':'asc'})
            .then(response => {
                this.isDownloading = false;
                this.zoneData = response.data.result.data;
                this.downloadsCSV();
            });
        },
        sortingChanged(ctx){
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getDeliveryZone();
        },
        deleteZone(id){
            if(confirm("Do you really want to delete?")){
                deliveryZoneService.deleteZone({id:id})
                .then(response => {
                    if (response.data.code === 200) {
                        this.getDeliveryZone();
                        success_message(response.data.message);
                    } else {
                        error_message(response.data.message);
                    }
                });
            }
        }
    }
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page">
                    <div class="page-title-left">
                        <div class="avatar-xs mr-3">
                            <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                                <i class="bx bx-map-alt"></i>
                            </span>
                        </div>
                        <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Delivery Zones') }}({{zoneCount}})</h4>
                    </div>
                    <div class="page-title-right d-flex">
                        <router-link v-if="$auth.hasPermission(config.permissions.delivery_zone_write)" :to="{name: 'delivery-zone-add'}" class="btn btn-success btn-rounded mr-2 add-btn">
                        <i class="mdi mdi-plus mr-1"></i> {{ trans.get('__JSON__.Add Delivery Zone') }}
                        </router-link>
                        <!-- <button @click="zoneExportCsv" class="btn btn-primary btn-rounded export-btn" v-if="isDownloading" disabled>{{ trans.get('__JSON__.Exporting...') }}</button>
                        <button @click="zoneExportCsv" class="btn btn-primary btn-rounded export-btn" v-else>
                            {{ trans.get('__JSON__.Export To CSV') }}
                        </button>
                        <div class="d-flex m-vendor-btn">
                            <router-link :to="{name: 'delivery-zone-add'}"  v-if="$auth.hasPermission(config.permissions.delivery_zone_write)" class="btn btn-success btn-rounded mr-2 m-add-btn">
                                <i class="mdi mdi-plus"></i>
                            </router-link>
                            <button
                                @click="zoneExportCsv"
                                class="btn btn-primary btn-rounded m-export-btn"
                            ><i class="bx bx-archive-in"></i></button>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="row list-table-main">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-2 offset-sm-8">
                                <div class="form-group">
                                    <div class="date-range-list">
                                        <label>{{ trans.get('__JSON__.Status') }} :</label>
                                        <select class="custom-select" v-model="status" @change="searchData()">
                                            <option value="">{{ trans.get('__JSON__.All') }}</option>
                                            <option value="1" selected>{{ trans.get('__JSON__.Active') }}</option>
                                            <option value="0">{{ trans.get('__JSON__.Inactive') }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="search-box mr-2 mb-2 d-inline-block">
                                    <div class="date-range-list">
                                        <label>{{ trans.get('__JSON__.Search') }} :</label>
                                        <div class="position-relative">
                                            <input type="text" class="form-control" @input="searchData()" v-model="search" :placeholder="trans.get('__JSON__.Search Placeholder')" />
                                            <i class="bx bx-search-alt search-icon"></i>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 table-main-list delivery-zone-table table-responsive">
                                <b-table
                                    :items="zones"
                                    :fields="fields"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :no-local-sorting="true"
                                    @sort-changed="sortingChanged"
                                    :busy="loading"
                                    show-empty
                                >
                                    <template #table-busy>
                                        <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>{{trans.get('__JSON__.Loading...')}}</strong>
                                        </div>
                                    </template>
                                
                                    <template v-slot:cell(id)="data">
                                        <span>{{ data.item.id }}</span>
                                    </template>

                                    <template v-slot:cell(image)="data">
                                        <div v-if="data.item.image">
                                            <img alt title="image"
                                                class="vendor-img avatar-xs"
                                                :src="config.zone+'original/'+data.item.image"
                                                @error="$event.target.src=config.basepath+'no-img.png'"
                                            />   
                                        </div>
                                        <div v-else>
                                            <img class="vendor-img avatar-xs" :src="config.basepath+'no-img.png'" alt />
                                        </div>
                                    </template>

                                    <template v-slot:cell(name)="data">
                                        <h5 class="font-size-14">{{ data.item.name }}</h5>
                                    </template>

                                    <template v-slot:cell(status)="data" >
                                        <div v-if="data.item.status == '1'" class="badge badge-pill badge-soft-success font-size-12">
                                            {{ trans.get('__JSON__.Active') }}
                                        </div>
                                        <div v-else class="badge badge-pill badge-soft-danger font-size-12">
                                            {{ trans.get('__JSON__.Inactive') }}
                                        </div>
                                    </template>
                                    
                                    <template v-slot:cell(action)="data">
                                        <div class="vendor-btn">
                                            <router-link
                                            v-if="$auth.hasPermission(config.permissions.delivery_zone_write)"
                                            class="btn btn-success btn-sm btn-rounded"
                                            :to="{ name: 'delivery-zone-edit', params: { id: base64(data.item.id)}}">{{ trans.get('__JSON__.Edit') }}
                                            </router-link>
                                            <button
                                                type="submit"
                                                @click="deleteZone(base64(data.item.id))"
                                                class="btn btn-danger btn-sm btn-rounded ml-1"
                                            >{{ trans.get('__JSON__.Delete') }}</button>
                                        </div>
                                    </template>

                                    <template #empty>
                                        <p class="text-center">{{ trans.get('__JSON__.No Delivery Zone') }}</p>
                                    </template>
                                </b-table>  
                            </div>
                            <div class="row col-sm-5 offset-sm-7">
                                <div class="col">
                                    <div class="dataTables_paginate paging_simple_numbers float-right">
                                        <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <pagination :data="paginations" :limit="limit" @pagination-change-page="getDeliveryZone"></pagination>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
